import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { environment } from '../../../../../environments/environments'
import { NexteoService } from '../nexteo/nexteo.service'
import { AccessResponse } from 'src/app/core/models/auth/session-data.model'
import { RedirectReasonCode } from 'src/app/core/models/others/redirect-reason.model'
import { skipAuthHeader } from 'src/app/core/interceptors/http.context'

@Injectable({
  providedIn: 'root',
})
export class ClaveunicaLoginService {
  protected client_id = 'client_id=' + environment.claveunica.claveunica_client_id
  protected redirect_uri = environment.claveunica.claveunica_login_uri
  protected response_type = 'response_type=code'
  protected scope = 'scope=openid run name'

  constructor(private http: HttpClient, private nexteoService: NexteoService) { }

  redirect(): void {
    const url = environment.claveunica.redirect_login + '/openid/authorize'
    const state = 'state=' + this.generateHash(30)
    const redirect =
      url +
      `?${this.client_id}&${this.response_type}&${this.scope}&redirect_uri=${encodeURIComponent(this.redirect_uri)}&${state}`
    window.location.href = redirect
  }

  async login(accessCode: string, accessState: string) {
    const url = environment.claveunica.auth_api + '/login/clave-unica/token'

    const body = {
      code: accessCode,
      state: accessState,
      env: environment.env,
    }

    return this.http.post<AccessResponse>(url, body, { context: skipAuthHeader() })
  }

  refresh(refreshToken: string) {
    const url = environment.claveunica.auth_api + '/login/clave-unica/token/refresh'
    return this.http.post<AccessResponse>(url, { refreshToken }, { context: skipAuthHeader() })
  }

  logout(refreshToken: string, redirectReason?: RedirectReasonCode) {
    const url = environment.claveunica.auth_api + '/login/clave-unica/logout'
    const body = {
      env: environment.env,
      reason: redirectReason || null,
      refreshToken
    }
    return this.http.post<any>(url, body, { context: skipAuthHeader() })
  }

  private generateHash(length: number): string {
    let hash = ''
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length)
      hash += chars.charAt(randomIndex)
    }
    return hash
  }
}
